import styled from "styled-components";

export const DateWrapper = styled.div`
  width: 175px;
`;
